import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const forbiddenCharacters = [':', '/', '<', '>', '\\'];

export function hasForbiddenCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value as string | null | undefined;

        if (!value || value.trim().length === 0) {
            return null;
        }

        if (forbiddenCharacters.some(char => value.includes(char))) {
            return { forbiddenCharacters: true }
        }

        return null;
    };
}